import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
var tippys = [];

(function () {
  var lastMouseOverElement = null;
  document.addEventListener("mouseover", function (event) {
    var element = event.target;

    if (element instanceof Element && element !== lastMouseOverElement) {
      lastMouseOverElement = element;
      var id = "tippyEllipsizedEl";
      var innerRun = false;

      var inner = function inner(content, el) {
        innerRun = true;
        document.querySelectorAll("." + id).forEach(function (elem) {
          elem.classList.remove(id);
        });
        el.classList.add(id);
        var inst = tippy("." + id, {
          content: content,
          delay: [0, 0],
          allowHTML: true
        });
        inst.forEach(function (i) {
          i.show();
        });
        tippys = [].concat(tippys, inst);

        if (content === el.getAttribute("title")) {
          el.removeAttribute("title");
        }
      };

      var levels = 6;
      var dataTip;
      var el = element;

      for (var index = 0; index < levels; index++) {
        var _el$textContent;

        if (!el) continue;
        var style = window.getComputedStyle(el);
        var whiteSpace = style.getPropertyValue("white-space");
        var textOverflow = style.getPropertyValue("text-overflow");
        dataTip = el.getAttribute("data-tip");
        var isEllipsized = whiteSpace === "nowrap" && textOverflow === "ellipsis";

        if (dataTip) {
          inner(dataTip, el);
          continue;
        } else if (isEllipsized && el.offsetWidth < el.scrollWidth - 4 && //the -4 is adding a teeny bit of tolerance to fix issues with the column headers getting tooltips even when fully visible
        !el.classList.contains("no-data-tip") && el.textContent && ((_el$textContent = el.textContent) == null ? void 0 : _el$textContent.trim == null ? void 0 : _el$textContent.trim().length) !== 0) {
          inner(el.textContent, el);
          continue;
        } else if (isEllipsized && el.offsetWidth >= el.scrollWidth) {// break; //tnr: i don't think we need this..
        }

        el = el.parentElement;
      }

      if (!innerRun) {
        //clear old tippys
        tippys.forEach(function (t) {
          t.destroy();
        });
        tippys = [];
      }
    }
  });
})();